import { useEffect, useState } from "react";
import axios from "axios";

interface Option {
  value: string;
  label: string;
}

interface UseMasterUserOptionsResult {
  options: Option[];
  loading: boolean;
  error: any;
}

export const useMasterUserOptions = (managementService: string): UseMasterUserOptionsResult => {
  const [options, setOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const url = `${managementService}/masterUser`;
        const response = await axios.get(url);

        const formattedOptions =
          response?.data?.result?.map((item: any) => ({
            value: item?.userId,
            label: item?.name,
          })) || [];
        setOptions(formattedOptions);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [managementService]);

  return { options, loading, error };
};
